fx.ns("shared.renderers", class BackgroundRenderer extends fx.Component{
    
	constructor(data)
	{
		super(data);
	}

	contextMenu(e)
	{
        let items = [  {label : fx.text("Appliquer"), code : "apply"}];

        if (fx.get("app") != "frame")
            items.push( {label : fx.text("Appliquer à toutes les pages"), code : "applyall"} );

        return items;
	}

	onContextMenu(e)
	{
		switch(e.detail.code)
		{
			case "apply":
					this.data.event("apply-background", {content : this.data.id});
				break;
			case "applyall":
					this.data.event("apply-background-all", {content : this.data.id});
				break;
		}
	}


	render()
	{
        return '<img class="draggable" data-width="' + this.data.width + '" data-height="' + this.data.height + '" data-bgcolor="' + this.data.bgcolor + '" data-behaviour="add-component" data-class="Background" src="' + this.data.thumb + '" data-id="' + this.data.id + '" >';
	}

	
});
